module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Bold.65bca5ed.woff";